import React, { useEffect, useState } from "react";
import GlobalHeader from "../../../components/header";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import useSnack from "../../../hooks/useSnack";
import useApi from "../../../hooks/useApi";
import Footer from "../../../components/footer";
import SnackAlert from "../../../components/SnackAlert";
import SwiperImages from "../../../components/SwiperImages";
import ListingDetails from "../../../components/ListingDetails";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import BathtubIcon from "@mui/icons-material/Bathtub";
import { Link } from "react-router-dom";
import { AutoGraph, KingBed } from "@mui/icons-material";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import CheckIcon from "../../../images/check-mark.svg";

const ContactMessage = ({ setView }) => {
  return (
    <Stack>
      <Box
        sx={{
          width: { xs: 100, sm: 120, lg: 100 },
          textAlign: "center",
          marginInline: "auto",
          mb: 2,
        }}
      >
        <img src={CheckIcon} style={{ width: "100%", height: "100%" }} />
      </Box>
      <Typography
        component="h3"
        variant="h6"
        sx={{
          textAlign: "center",
          marginInline: "auto",
          mb: 1,
        }}
      >
        LISTO
      </Typography>
      <Typography
        fontSize="large"
        sx={{
          fontWeight: "normal",
          textAlign: "center",
          width: "50%",
          marginInline: "auto",
          mb: 4,
        }}
      >
        Ha sido enviada la solicitud, pronto nos pondremos en contacto contigo
        para darte más detalles del inmueble. ¡Gracias por usar Invirte!
      </Typography>
      <Button
        LinkComponent={Link}
        to={"/property"}
        variant="contained"
        sx={{
          marginInline: "auto",
          width: "fit-content",
          px: 4,
          color: "white",
          "&:hover": {
            backgroundColor: "primary.300",
          },
        }}
      >
        REGRESAR
      </Button>
    </Stack>
  );
};

function DetailsProperty() {
  const navigate = useNavigate();
  const params = useParams();

  //  MAIN REQUEST
  const GetDetails = async () => {
    setOpenBackDrop(true);
    loadApi(`home/state/${params.id}`, true, "get")
      .then((response) => {
        const propertyDetails = response.data;
        if (!propertyDetails) {
          navigate("/property");
          return;
        }
        const dataMapping = {
          Precio: parseInt(propertyDetails.price).toLocaleString("es-ES") + "Є",
          m2: propertyDetails.m2,
          // TIPO: filteredData[0].type,
          Ubicación: propertyDetails.location,
          Propósito: propertyDetails.purpose_use,
          Habitaciones: propertyDetails.bedrooms,
          Baños: propertyDetails.bathrooms,
        };
        const updatedListData = listData.map((item) => ({
          ...item,
          value: dataMapping[item.title] || item.value,
        }));
        setListData(updatedListData);
        setDetailData(propertyDetails);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => setOpenBackDrop(false));
  };

  // DATA
  const [detailData, setDetailData] = useState(false);
  const [listData, setListData] = useState([
    {
      title: "Precio",
      icon: LocalAtmIcon,
      value: "",
    },
    {
      title: "m2",
      icon: AspectRatioIcon,
      value: "",
    },
    // {
    //   title: "TIPO",
    //   icon: MapsHomeWorkIcon,
    //   value: "",
    // },
    {
      title: "Ubicación",
      icon: FmdGoodOutlinedIcon,
      value: "",
    },

    {
      title: "Propósito",
      icon: ArticleOutlinedIcon,
      value: "",
    },
    {
      title: "Habitaciones",
      icon: KingBed,
      value: "",
    },
    {
      title: "Baños",
      icon: BathtubIcon,
      value: "",
    },
  ]);

  // UTILS
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const { loadApi, loadingApi } = useApi();
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const [showMessageSuccess, setShowMessageSuccess] = useState(false);

  const handleRegisterInterest = () => {
    setOpenBackDrop(true);
    loadApi(`transaction/${params.id}`, true, "post")
      .then(() => {
        setShowMessageSuccess(true);
      })
      .catch((e) => {
        showSnack(e.message);
      })
      .finally(() => setOpenBackDrop(false));
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    GetDetails();
  }, []);
  console.log(detailData)
  return (
    <>
      <GlobalHeader />
      <Stack
        component="main"
        sx={{
          minHeight: "90vh",
          width: { xs: "100vw", sm: "90vw", md: "85vw", lg: "65vw" },
          marginInline: "auto",
          backgroundColor: "white",
          pb: 4,
          placeContent: "center",
        }}
      >
        {showMessageSuccess ? (
          <ContactMessage setView={setShowMessageSuccess} />
        ) : (
          detailData && (
            <>
              {/* IF THE ARRAY IS EMPTY THIS WILL BE SHOW IT */}
              {detailData.error && (
                <Stack sx={{ mt: 10 }}>
                  <Typography textAlign="center" variant="h5">
                    Lo sentimos, datos no encontrados
                  </Typography>
                </Stack>
              )}
              {/* IN CASE THAT THE ERROR KEY DOESNT EXIST, THE DATA IS RENDERED */}
              {!detailData.error && (
                <Stack>
                  <SwiperImages data={detailData.photo_profile} section="property" />
                  <Stack px={{ xs: 2, md: 4 }}>
                    <Stack component="section" pt={5}>
                      <Typography component="h2" variant="h5" mb={2}>
                        {detailData.name}
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          backgroundColor: "secondary.typePropertySpan",
                          width: "fit-content",
                          px: 2,
                          py: 0.5,
                          borderRadius: 3,
                          mb: 5,
                          fontWeight: "normal",
                        }}
                      >
                        {detailData.type}
                      </Typography>
                      <Stack>
                        <Grid container spacing={2}>
                          {(listData || []).map((detailData, index) => {
                            return (
                              <Grid item xs={6} md={4} key={index}>
                                <Box
                                  sx={{
                                    boxShadow: "2px 3px 5px #7d7d7d24",
                                    borderRadius: 2,
                                    p: 2,
                                  }}
                                >
                                  <Box
                                    display={"flex"}
                                    alignItems={"center"}
                                    gap={2}
                                    mb={1}
                                  >
                                    <detailData.icon
                                      sx={{
                                        color: "gray",
                                        backgroundColor: "#F3F4F6",
                                        p: 1,
                                        borderRadius: "50%",
                                      }}
                                    />
                                    <Typography
                                      component="h3"
                                      variant="subtitle1"
                                      fontWeight={400}
                                      color="#303030ed"
                                    >
                                      {detailData.title}
                                    </Typography>
                                  </Box>
                                  <Typography
                                    component="span"
                                    fontFamily={"sans-serif"}
                                  >
                                    {detailData.value}
                                  </Typography>
                                </Box>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </Stack>
                    </Stack>
                    <Stack
                      component="section"
                      mb={{ xs: 2, lg: 5 }}
                      mt={{ xs: 3, lg: 7 }}
                    >
                      <Typography component="h3" variant="h5" mb={2}>
                        Descripción
                      </Typography>
                      <Typography sx={{ fontWeight: "normal", mb: 5 }}>
                        {detailData.information}
                      </Typography>
                    </Stack>
                    <Stack mb={4}>
                      <SwiperImages data={detailData.gallery} slides={3} />
                    </Stack>
                    <Button
                      variant="contained"
                      sx={{
                        color: "white",
                        width: "fit-content",
                        ml: "auto",
                        mb: { xs: 2, md: 5 },
                      }}
                      onClick={handleRegisterInterest}
                    >
                      ME INTERESA
                    </Button>
                  </Stack>
                </Stack>
              )}
            </>
          )
        )}
      </Stack>
      <Footer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackDrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
    </>
  );
}

export default DetailsProperty;
